import { render, staticRenderFns } from "./atom.vue?vue&type=template&id=97e14b20&scoped=true&"
import script from "./atom.vue?vue&type=script&lang=js&"
export * from "./atom.vue?vue&type=script&lang=js&"
import style0 from "./atom.vue?vue&type=style&index=0&id=97e14b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e14b20",
  null
  
)

export default component.exports